import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

type Props = {
  breakpoint: number;
  children: React.ReactNode;
};

export const PopoverButtonGroup = ({ breakpoint, children }: Props) => (
  <div
    css={css`
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: ${theme.spacing(1)};

      button {
        width: auto;
        min-width: unset;
      }

      @media (min-width: ${breakpoint + 1}px) {
        display: none;
      }
    `}
  >
    {children}
  </div>
);
